import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentDialogService} from "../../services/agent-dialogs-service.service";
import {AgentsAlerts} from "../../services/agents-alerts.service";
import {AgentModel} from "../../angular/models/agent.model";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class AgentInfoCtrl implements IController {

  agent: AgentModel;

  public country: any;
  public placeList: any;

  constructor(private agentDialogService: AgentDialogService, private splitService: SplitService, private $log,
              private agentsAlerts: AgentsAlerts, private analyticsService: AnalyticsService) {
  }

  $onInit() {
    this.country = this.splitService.getCountryCode();
  }

  openEditPersonalInfo(event) {
    this.agentDialogService.editUserPersonalInfo(event, this.agent)
      .then((updatedAgent) => {
        this.analyticsService.trackEvent('Agents Actions', 'Edit Personal', 'Confirm');
        this.agentsAlerts.updateSuccess();
        this.agent = updatedAgent;
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.updateError(error);
          this.analyticsService.trackEvent('Agents Actions', 'Edit Personal', 'Error');
        } else {
          this.$log.info('Dialog Closed');
          this.analyticsService.trackEvent('Agents Actions', 'Edit Personal', 'Cancel');
        }
      })
  }

  openEditResidentialAddress(event) {
    this.agentDialogService.editUserResidentialAddress(event, this.agent)
      .then((updatedAgent) => {
        this.agent = updatedAgent;
        this.agentsAlerts.updateSuccess();
        this.analyticsService.trackEvent('Agents Actions', 'Edit Residential', 'Confirm');
        if (_.isEqual(this.country, 'US') && _.has(updatedAgent.address, 'place')) {
          this.placeList = updatedAgent.address.place.split(/\s*,\s*/);
        }
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.updateError(error);
          this.analyticsService.trackEvent('Agents Actions', 'Edit Residential', 'Error');
        } else {
          this.$log.info('Dialog Closed');
          this.analyticsService.trackEvent('Agents Actions', 'Edit Residential', 'Cancel');
        }
      })
  }

  openEditLicenseInfo(event) {
    this.agentDialogService.editAgentLicenseInfo(event, this.agent)
      .then((updatedAgent) => {
        this.agent = updatedAgent;
        this.agentsAlerts.updateSuccess();
        this.analyticsService.trackEvent('Agents Actions', 'Edit License', 'Confirm');
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.updateError(error);
          this.analyticsService.trackEvent('Agents Actions', 'Edit License', 'Error');
        } else {
          this.$log.info('Dialog Closed');
          this.analyticsService.trackEvent('Agents Actions', 'Edit License', 'Cancel');
        }
      })
  }

  openEditComments(event) {
    this.agentDialogService.editComments(event, this.agent)
      .then((updatedAgent) => {
        this.agent = updatedAgent;
        this.agentsAlerts.updateSuccess();
        if (_.isEqual(this.country, 'US') && _.has(updatedAgent.address, 'place')) {
          this.placeList = updatedAgent.address.place.split(/\s*,\s*/);
        }
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.updateError(error);
          this.analyticsService.trackEvent('Agents Actions', 'Edit Residential', 'Error');
        } else {
          this.$log.info('Dialog Closed');
          this.analyticsService.trackEvent('Agents Actions', 'Edit Residential', 'Cancel');
        }
      })
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentInfo', {
    bindings: {
      agent: '<'
    },
    template: require('./agent-info.html').default,
    controller: AgentInfoCtrl
  });

